import { render, staticRenderFns } from "./SaveQuery.vue?vue&type=template&id=7d80e650"
import script from "./SaveQuery.vue?vue&type=script&lang=js"
export * from "./SaveQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports